import { render, staticRenderFns } from "./ProductItemDetail.vue?vue&type=template&id=225cdf4f&scoped=true&"
import script from "./ProductItemDetail.vue?vue&type=script&lang=js&"
export * from "./ProductItemDetail.vue?vue&type=script&lang=js&"
import style0 from "./ProductItemDetail.vue?vue&type=style&index=0&id=225cdf4f&lang=scss&scoped=true&"
import style1 from "./ProductItemDetail.vue?vue&type=style&index=1&id=225cdf4f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225cdf4f",
  null
  
)

export default component.exports